export default (state, {
  instanceKey
}) => {
  let newFieldValue = {
    ...state
  };

  newFieldValue[`${instanceKey}_initializing`] = true;
  newFieldValue[`${instanceKey}_isSubmitting`] = false;

  return newFieldValue;
};
